<script lang="ts">
import type { HTMLAttributes } from 'vue'

export type FieldOrientation = 'vertical' | 'horizontal'

export interface FieldProps {
  orientation?: FieldOrientation
  class?: HTMLAttributes['class']
}
</script>

<script setup lang="ts">
import { cn } from '#ui-kit/lib/utils'

const props = withDefaults(defineProps<FieldProps>(), {
  orientation: 'vertical',
})
</script>

<template>
  <div
    role="group"
    data-slot="field"
    :data-orientation="props.orientation"
    :class="
      cn(
        'flex gap-2',
        props.orientation === 'horizontal' ? 'flex-col gap-1 md:flex-row md:items-start md:gap-2' : 'flex-col',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>
